import * as React from "react";
const SvgCopier = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.625 1V9.973h1.498V2.508h9.754v7.465h1.498V1H12Zm-3.754 9.566v10.878h3.754v.812h12.75v-.813h3.754V10.566H12Zm1.508 1.498H20.62v7.872h-2.246v-1.813H5.625v1.813H3.379V16Zm3.744 7.567h9.754v1.117H7.123v-.059z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCopier;
